import { InjectionToken } from '@angular/core';


export const INITIAL_TOKEN_NAME = new InjectionToken('jwt-token-managment INITIAL_JWT_TOKEN_NAME');
